export default {
  name: 'ur',
  el: {
    breadcrumb: {
      label: 'بریڈکرام',
    },
    colorpicker: {
      confirm: 'ٹھیک ہے',
      clear: 'صاف کریں',
      defaultLabel: 'رنگ چنندہ',
      description: 'موجودہ رنگ ہے {color}. نئے رنگ کو منتخب کرنے کے لیے اینٹر دبائیں.',
      alphaLabel: 'الفہ ویلیو چنیں',
    },
    datepicker: {
      now: 'اب',
      today: 'آج',
      cancel: 'منسوخ کریں',
      clear: 'صاف کریں',
      confirm: 'ٹھیک ہے',
      dateTablePrompt: 'ماہ کے دن کو منتخب کرنے کے لیے ارو کیز اور انٹر کا استعمال کریں',
      monthTablePrompt: 'ماہ کو منتخب کرنے کے لیے ایرو کیز اور انٹر استعمال کریں',
      yearTablePrompt: 'سال کو منتخب کرنے کے لیے ایرو کیز اور انٹر استعمال کریں',
      selectedDate: 'منتخب تاریخ',
      selectDate: 'تاریخ منتخب کریں',
      selectTime: 'وقت منتخب کریں',
      startDate: 'شروع کی تاریخ',
      startTime: 'شروع کا وقت',
      endDate: 'اختتامی تاریخ',
      endTime: 'اختتامی وقت',
      prevYear: 'پچھلا سال',
      nextYear: 'اگلے سال',
      prevMonth: 'پچھلا مہینہ',
      nextMonth: 'اگلے مہینے',
      year: '',
      month1: 'جنوری',
      month2: 'فبروری',
      month3: 'مارچ',
      month4: 'اپریل',
      month5: 'ممکن ہے',
      month6: 'جون',
      month7: 'جولائی',
      month8: 'اگست',
      month9: 'سپتمبر',
      month10: 'اکتوبر',
      month11: 'نومبر',
      month12: 'دسمبر',
      week: 'ہفتہ',
      weeks: {
        sun: 'Sun',
        mon: 'پیر',
        tue: 'منگل',
        wed: 'بدھ',
        thu: 'جمعرات',
        fri: 'جمعہ',
        sat: 'سات',
      },
      weeksFull: {
        sun: 'اتوار',
        mon: 'پیر',
        tue: 'मंगलवार',
        wed: 'بدھ',
        thu: 'جمعرات',
        fri: 'جمعہ',
        sat: 'سنیچر',
      },
      months: {
        jan: 'جنوری',
        feb: 'فروری',
        mar: 'مار',
        apr: 'Apr',
        may: 'ممکن ہے',
        jun: 'جون',
        jul: 'Jul',
        aug: 'Aug',
        sep: 'Sep',
        oct: 'اکتوبر',
        nov: 'Nov',
        dec: 'Dec',
      },
    },
    inputNumber: {
      decrease: 'عدد کم کریں',
      increase: 'عدد میں اضافہ کریں',
    },
    select: {
      loading: 'لوڈ ہو رہا ہے',
      noMatch: 'مطابقت رکھنے والی ڈیٹا نہیں',
      noData: 'کوئی ڈیٹا نہیں',
      placeholder: 'منتخب کریں',
    },
    mention: {
      loading: 'لوڈ ہو رہا ہے',
    },
    dropdown: {
      toggleDropdown: 'ڈراپ ڈاؤن کو ٹوگل کریں',
    },
    cascader: {
      noMatch: 'مطابقت رکھنے والی ڈیٹا نہیں',
      loading: 'لوڈ ہو رہا ہے',
      placeholder: 'منتخب کریں',
      noData: 'کوئی ڈیٹا نہیں',
    },
    pagination: {
      goto: 'پر جاۓ',
      pagesize: '/صفحہ',
      total: 'کل {total}',
      pageClassifier: '',
      page: 'صفحہ',
      prev: 'پچھلے صفحے پر جائیں',
      next: 'اگلے صفحے پر جاؤ',
      currentPage: 'صفحہ {pager}',
      prevPages: 'پچھلے {pager} صفحات',
      nextPages: 'اگلے {pager} صفحات',
      deprecationWarning: 'غیر مستند استعمالات کی شناخت ہوئی ہے، مزید تفصیلات کے لیے براہ کرم el-pagination کی دستاویزیں دیکھیں',
    },
    dialog: {
      close: 'اس ڈائیلاگ کو بند کریں',
    },
    drawer: {
      close: 'یہ ڈائیلاگ بند کریں',
    },
    messagebox: {
      title: 'پیغام',
      confirm: 'ٹھیک ہے',
      cancel: 'منسوخ کریں',
      error: 'غیر قانونی ان پٹ',
      close: 'اس ڈائیلاگ کو بند کریں',
    },
    upload: {
      deleteTip: 'حذف کرنے کے لیے ڈیلیٹ دبائیں',
      delete: 'حذف کریں',
      preview: 'پریویو',
      continue: 'جاری رکھیں',
    },
    slider: {
      defaultLabel: '{min} اور {max} کے درمیان سلائیڈر',
      defaultRangeStartLabel: 'شروع کی قیمت چنیں',
      defaultRangeEndLabel: 'اختتامی قدر چنیں',
    },
    table: {
      emptyText: 'کوئی ڈیٹا نہیں',
      confirmFilter: 'تصدیق کریں',
      resetFilter: 'ری سیٹ',
      clearFilter: 'تمام',
      sumText: 'جمع',
    },
    tour: {
      next: 'اگلے',
      previous: 'پچھلا',
      finish: 'ختم کریں',
    },
    tree: {
      emptyText: 'کوئی ڈیٹا نہیں',
    },
    transfer: {
      noMatch: 'مطابقت کے دیت نہیں',
      noData: 'کوئی ڈیٹا نہیں',
      titles: ['فہرست 1', 'فہرست 2'],
      filterPlaceholder: 'کلیدی لفظ درج کریں',
      noCheckedFormat: '{total} آئٹمز',
      hasCheckedFormat: '{checked}/{total} جانچا گیا',
    },
    image: {
      error: 'ناکام',
    },
    pageHeader: {
      title: 'پیچھے',
    },
    popconfirm: {
      confirmButtonText: 'جی ہاں',
      cancelButtonText: 'نہیں',
    },
    carousel: {
      leftArrow: 'کاروسل تیر بائیں',
      rightArrow: 'کاروسل تیرہ دائیں',
      indicator: 'کاروسل کو انڈекс {index} پر تبدیل کریں',
    },
  },
}
